<template>
  <div :class="'base-create ' + (isDisabledComponent ? 'create-class-com-disable' : '') ">
      <div class="base-create-header">
        <h1>
          <span class="circle-step">1</span>
          <span>
            {{modalTitle}}
            <el-tooltip
              :content="$t($i18nLabelsHelper(organizationType, 'create_group_flow.group_details.team_detail_tooltip'))"
            >
              <i class="el-icon-warning-outline"/>
            </el-tooltip>
          </span>
        </h1>
      </div>
      <div class="base-create-body">
        <el-form
          :rules="rules"
          :disabled="isDisabledComponent"
          :model="classDetails"
          class="create-edit-form"
          ref="firstForm"
        >
          <elsa-input
            v-model="classDetails.className"
            :label="$t($i18nLabelsHelper(organizationType, 'group_name'))"
            :placeholder="$t($i18nLabelsHelper(organizationType, 'create_group_flow.group_details.group_name_input_placeholder'))"
            name="className"
          />
          <el-row class="form-row">
            <el-col :md="12" :xs="24">
              <div class="pick-teacher">
                <elsa-select
                  popper-class="emails-list-popover"
                  name="teacher"
                  :label="$t($i18nLabelsHelper(organizationType, 'teacher'))"
                  :options="this.teachers.length > 0 ? this.teachers : this.admins"
                  :placeholder="$t($i18nLabelsHelper(organizationType, 'select_teacher'))"
                  @change="changeTeacher"
                  v-model.lazy="classDetails.teacher"
                  :no-data-text="$t($i18nLabelsHelper(organizationType, 'no_teachers_available'))"
                  filterable
                />
                <div class="invite-teacher" @click="openInviteTeacherModal">
                  <i class="el-icon-circle-plus-outline" />
                  {{ $t($i18nLabelsHelper(organizationType, 'add_new_teacher')) }}
                </div>
              </div>
            </el-col>
            <el-col :md="12" :xs="24">
              <el-row class="input-wrapper-assessment">
                <el-col :md="12" :xs="24">
                  <elsa-date
                    v-model="classDetails.startDate"
                    type="date"
                    :label="$t('classes.create_class_flow.class_details.start_day')"
                    class="first-assessment elsa-input"
                    :placeholder="$t('classes.create_class_flow.class_details.pick_a_day')">
                  </elsa-date>
                </el-col>
                <el-col :md="12" :xs="24">
                  <elsa-date
                    v-model="classDetails.endDate"
                    type="date"
                    :label="$t('classes.create_class_flow.class_details.end_date')"
                    class="second-assessment elsa-input"
                    :placeholder="$t('classes.create_class_flow.class_details.pick_a_day')">
                  </elsa-date>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <invite-teacher
        :dialogVisible="modals.showInviteTeacherModal"
        v-on:closed="modals.showInviteTeacherModal = false"
        :organizationType="organizationType"
        @newTeacher="setTeacher"
      />
  </div>
</template>

<script>
  import ElsaInput from '@/components/common/Input'
  import ElsaDate from '@/components/common/dateInput'
  // import ElsaSearch from '@/components/common/Search'
  import { handleFormValidation } from '../../../helpers/formValidationHelper'
  // import DatePicker from '@/components/common/DatePicker'
  import InviteTeacher from '@/components/modals/classes/InviteTeacher'
  import { mapGetters, mapActions } from 'vuex'
  import ElsaSelect from '@/components/common/Select'
  import { path, pathOr } from 'ramda';
  import { isToday, isFuture, addDays } from 'date-fns'
  import { TEACHER, ADMIN } from '../../../constants/userRoles'
  import { toDate } from 'date-fns'
  import axios from '@/utils/axios'

  export default {
    props: {
      currentStep: {
        type: Number,
        default: 1,
      },
      componentStep: {
        type: Number,
        default: 1,
      },
      editMode: {
        type: Boolean,
        default: false
      },
      tertiaryFunction: {
        type: Function,
        default: null
      },
      organizationType: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        form: {
          className: path(['classDetails', 'className'])(this),
          teacher: path(['classDetails','teacher'])(this)
        },
        rules: {
          className: { required: true, type: 'string', message: this.$t(this.$i18nLabelsHelper(this.organizationType, 'errors.please_provide_group_name')) },
          teacher: [
            { type: 'email', message: this.$t('classes.create_class_flow.class_details.invalid_email_msg') },
          ]
        },
        modals: {
          showInviteTeacherModal: false
        },
        teachers: [],
        admins: [],
      }
    },
    computed: {
       ...mapGetters({
        class: 'classes/getBuildingClass',
        currentOrganizationId: 'organization/currentOrganizationId'
      }),
      classDetails() {
        return this.class
      },
      modalTitle() {
        return this.currentStep === -1
          ? this.$t(this.$i18nLabelsHelper(this.organizationType, 'group_details'))
          : this.$t(this.$i18nLabelsHelper(this.organizationType, 'step_group_details'))
      },
      dateObject() {
        return {
          start: this.classDetails.startDate ? new Date(this.classDetails.startDate) : '',
          end: this.classDetails.endDate ? new Date(this.classDetails.endDate) : '',
        }
      },
      isDisabledComponent() {
        return ((this.currentStep > this.componentStep) && this.editMode == false)
      }
    },
    components: {
      ElsaInput,
      // DatePicker,
      // ElsaSearch,
      InviteTeacher,
      ElsaSelect,
      ElsaDate
    },
    async mounted () {
      try {
        const response = await this._getCurrentOrganizationUsersPage({ roles: TEACHER })
        const teachers = pathOr([],['data', 'results'])(response)
        this.teachers = teachers.map((teacher) => {
          return {
            label: this.getUserName(teacher),
            first_name: teacher.first_name,
            last_name: teacher.last_name,
            value: teacher.email
          }
        })
        if (this.teachers.length == 0) {
          const response = await this._getCurrentOrganizationUsersPage({ roles: ADMIN })
          const admins = pathOr([],['data', 'results'])(response)
          this.admins = admins.map((admin) => {
            return {
              label: this.getUserName(admin),
              first_name: admin.first_name,
              last_name: admin.last_name,
              value: admin.email
            }
          })
        }
      } catch(error) {
        error
      }
    },
    methods: {
      ...mapActions({
        updateBuildingClass: 'classes/updateBuildingClass'
      }),
      _getCurrentOrganizationUsersPage ({
        page = 1,
        roles = null,
        search = null,
      } = {}) {
        const params = {
          page,
          roles,
          search,
        }

        return axios.get(`v1/organizations/${this.currentOrganizationId}/users`, { params })
      },
      dateChange(value) {
        this.updateBuildingClass({
          startDate: value.start,
          endDate: value.end
        })
      },
      setTeacher({ email, first_name, last_name }) {
        this.teachers.push({
          label: first_name + ' ' + last_name,
          value: email
        })
        this.updateBuildingClass({
          teacher: email,
          teacher_first_name: first_name,
          teacher_last_name: last_name
        })
      },
      handleContinueClick() {
        handleFormValidation(this.$refs.firstForm, this.validFormCallback, () => {})
      },

      validFormCallback() {
        this.$emit('next-step', this.currentStep)
      },
      handleCancelClick() {
        return this.$router.push({
          name: 'classes',
          params: {
            organizationId: this.currentOrganizationId
          }
        })
      },
      openInviteTeacherModal() {
        this.modals.showInviteTeacherModal = true
      },
      // disabledDate(time) {
      //   const date = new Date(time)
      //   return !(isFuture(date) || isToday(date))
      // },
      changeTeacher(teacherEmail) {
        const teacher = this.teachers.find(e => e.value === teacherEmail)
        const admin = this.admins.find(e => e.value === teacherEmail)
        this.updateBuildingClass({
          teacher_first_name: teacher ? teacher.first_name : admin.first_name,
          teacher_last_name: teacher ? teacher.last_name : admin.last_name
        })
      },
      getUserName(user) {
        if (user.first_name || user.last_name) {
          return user.first_name + ' ' + user.last_name
        } else {
          return user.email;
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .form-row {
    margin-top: 20px;
  }

  .pick-teacher {
    font-weight: 600;
    font-size: 14px;
    color: #478DFF;
    flex: 1;
    margin-right: 33px;
    max-width: 452px;

    .invite-teacher {
      cursor: pointer;
      margin-top: 16px;
      float: left;
    }
  }

  .create-edit-form .form-row .el-form-item.elsa-input:not(:last-of-type) {
    margin-right: 0;
  }

  ::v-deep .elsa-section {
    background-color: #F2F7FA;
  }
  ::v-deep .el-date-editor.el-input {
    width: 200px;
  }
  ::v-deep .elsa-input .el-input .el-input__inner{
    width: 100%;
  }

</style>
